import {
  Goal,
  ID,
  IDPrefixes,
  TaskListItemTypes,
  TaskListTreeItem,
} from '@griply/types';

import { createCompositeId } from '../encoded-ids/composite-id';

export const registerGoalDeadlineItems = (
  treeItems: Record<ID, TaskListTreeItem>,
  goals: Goal[],
  sectionId: ID,
) =>
  goals.forEach((goal) => {
    const goalItemId = createCompositeId(IDPrefixes.GoalDeadline, [goal.id]);
    treeItems[sectionId]?.children?.push(goalItemId);
    treeItems[goalItemId] = {
      id: goalItemId,
      name: goal.name,
      type: TaskListItemTypes.GoalDeadline,
    };
  });
